import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { ReactComponent as EllipsisVertical } from 'assets/icons/EllipsisVertical.svg';
import { ReactComponent as ShareIcon } from 'assets/icons/ShareFilledIcon.svg';

import { Button } from 'components/_basic/Button/Button';

import styles from '../ShareDocumentButton.module.scss';
import { IShareButtonProps as IProps } from '../types';

export const ShareButton: FC<IProps> = ({ isDisabled, onClick, shouldDocUpdate, isDocCreated }) => {
  const { t } = useTranslation();
  const { isAboveMobile } = useBreakpoints();

  if (isAboveMobile) {
    return (
      <Button
        endIcon={<EllipsisVertical />}
        variant="contained"
        size="large"
        onClick={onClick}
        disabled={isDisabled}
        isLoading={isDisabled}
      >
        <Box
          className={clsx({
            [styles.shareButtonText]: shouldDocUpdate,
            [styles.buttonTextWrapper]: shouldDocUpdate && isDocCreated,
          })}
          component="span"
        >
          {t('share')}
        </Box>
      </Button>
    );
  }

  return (
    <IconButton onClick={onClick} disabled={isDisabled}>
      <ShareIcon width={24} height={24} />
    </IconButton>
  );
};
